export const variableToString = (varObj: any) => Object.keys(varObj)[0]
/**
 * @deprectaed use @/components/Form/fieldName instead
 */
export const fieldName = (name: string, context?: string, index?: number, suffix: string = '') => {
	return context
		? typeof index === 'number'
			? `${context}[${index}][${name}]${suffix}`
			: `${context}[${name}]${suffix}`
		: typeof index === 'number'
			? `${name}[${index}]${suffix}`
			: name
}
export const createArray = (length: number = 0) => Array.from({ length: length }, (_, i) => i + 1)

export const isObject = (item: any) => item && typeof item === 'object' && !Array.isArray(item)
export const deepMerge = (target: any, source: any) => {
	const output = { ...target }

	if (isObject(target) && isObject(source)) {
		Object.keys(source).forEach((key) => {
			if (isObject(source[key])) {
				if (!(key in target)) Object.assign(output, { [key]: source[key] })
				else output[key] = deepMerge(target[key], source[key])
			} else {
				Object.assign(output, { [key]: source[key] })
			}
		})
	}
	return output
}

export const filterEnabledItems = (items: any) => items.filter((item: any) => item.enabled)

export const convertToEnglishWordList = (list: string[]) => {
	if (!list || list.length === 0) return ''
	if (list.length === 1) return list[0]
	if (list.length === 2) return list.join(' and ')
	return list.slice(0, -1).join(', ') + ', and ' + list.slice(-1)
}
